<script>
import { mapActions, mapGetters } from 'vuex';
import { required, email, minLength } from 'vuelidate/lib/validators';
import AddEditForm from '@/components/users/AddEditForm';
import SingleView from '@/components/elements/views/SingleView';

export default {
    page: {
        title: 'Manage User'
    },

    components: {
        AddEditForm
    },

    extends: SingleView,

    validations: {
        item: {
            email: {
                required,
                email,
                isEmailTaken() {
                    return !this.isEmailTaken;
                }
            },
            roles: {
                required
            },
            firstName: {
                minLength: minLength(2)
            },
            lastName: {
                minLength: minLength(2)
            },
            nickname: {
                minLength: minLength(2)
            }
        }
    },

    data() {
        const {
            params: { id = null },
            query: { selectedRole }
        } = this.$route;

        return {
            backRoute: '/users',
            indexName: 'User',
            singleItemName: 'user',
            preview: false,
            item: {
                roles: [id] || !selectedRole ? [] : [selectedRole]
            },
            isEmailTaken: false
        };
    },

    computed: {
        ...mapGetters({
            ALL_ROLES: 'roles/ALL_ROLES',
            ADMIN_ROLE: 'roles/ADMIN',
            loggedUser: 'auth/loggedUser'
        }),

        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    methods: {
        ...mapActions({
            addItem: 'users/store',
            deleteItem: 'users/destroy',
            getItem: 'users/show',
            updateItem: 'users/update'
        })
    }
};
</script>
